import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      margin-left: -", "px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["calc(100% + ", "px)"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n\n  background-color: ", ";\n\n  height: ", "px;\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  margin: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { Card, CardContent, CardFooter } from '../Card';
import styled, { css } from '../utils/styling/styled-components';
import { theme } from '../theme';
import { MobileView } from './MobileView';
var DEFAULT_PAGE_MAX_WIDTH = 800;
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return props.maxWidth;
});
export var PageDivider = styled.div(_templateObject3(), function (props) {
  return props.containerPadding ? css(_templateObject4(), props.containerPadding * 2) : '100%';
}, function (props) {
  return props.thin ? props.theme.colors.ivory : props.theme.colors.ivoryLight;
}, function (props) {
  return props.thin ? 1 : 10;
}, function (props) {
  return props.containerPadding && css(_templateObject5(), props.containerPadding);
});
export var Page = function Page(_ref) {
  var navigation = _ref.navigation,
      className = _ref.className,
      content = _ref.content,
      _ref$cardMinHeight = _ref.cardMinHeight,
      cardMinHeight = _ref$cardMinHeight === void 0 ? 468 : _ref$cardMinHeight,
      footer = _ref.footer,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? DEFAULT_PAGE_MAX_WIDTH : _ref$maxWidth,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'large' : _ref$padding,
      _ref$isContentCenterA = _ref.isContentCenterAligned,
      isContentCenterAligned = _ref$isContentCenterA === void 0 ? true : _ref$isContentCenterA;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
    className: className,
    maxWidth: maxWidth
  }, navigation, /*#__PURE__*/React.createElement(Card, {
    minHeight: cardMinHeight,
    id: "page-card"
  }, /*#__PURE__*/React.createElement(CardContent, {
    padding: padding,
    isContentCenterAligned: isContentCenterAligned
  }, content), footer && /*#__PURE__*/React.createElement(CardFooter, null, footer))))), /*#__PURE__*/React.createElement(MediaQuery, {
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  }, /*#__PURE__*/React.createElement(MobileView, {
    className: className,
    navigation: navigation,
    content: content,
    footer: footer
  })));
};